var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-field',_vm._b({staticClass:"library-handle",scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('strong',[_c('u',[_vm._v("Section Header")])])]},proxy:true}])},'base-field',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }